import { useCallback, useEffect, useState } from 'react'

import api from '../../../api/api'

export const useGuestPasses = (clientId, { enabled = true, limit = 5 } = {}) => {
  const [guestPasses, setGuestPasses] = useState({
    data: {},
    skip: 0,
    isLoading: false,
  })

  const fetchGuestPasses = async (newSkip = 0, append = false) => {
    if (!clientId || !enabled || guestPasses.isLoading) {
      return
    }

    setGuestPasses((prev) => ({
      ...prev,
      isLoading: true,
    }))

    try {
      const response = await api.getGuestPassesByClientId(clientId, { skip: newSkip, limit })
      const newData = response.data

      setGuestPasses((prev) => ({
        data: {
          ...newData,
          guestPassVisits: append
            ? [...prev.data.guestPassVisits, ...newData.guestPassVisits]
            : newData.guestPassVisits,
        },
        skip: newSkip,
        isLoading: false,
      }))
    } catch (error) {
      console.error('Error fetching guest passes:', error)
      setGuestPasses((prev) => ({
        ...prev,
        isLoading: false,
      }))
    }
  }

  const fetchMore = (reset = false) => {
    if (reset) {
      fetchGuestPasses(0, false)
    } else {
      fetchGuestPasses(guestPasses.skip + limit, true)
    }
  }

  const hasMore = guestPasses.skip + limit < guestPasses.data.total

  const addGuestPass = async (newGuestPass) => {
    setGuestPasses((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        total: prev.total + 1,
        guestPassVisits: [newGuestPass, ...prev.data.guestPassVisits],
      },
    }))
  }

  useEffect(() => {
    if (clientId && enabled) {
      fetchGuestPasses(0)
    }
  }, [clientId, enabled])

  return {
    ...guestPasses,
    hasMore: hasMore,
    fetchMore,
    addGuestPass,
  }
}

export const useUpdateGuessPassesData = (clientId) => {
  const [isLoading, setIsLoading] = useState(false)

  const fetchUpdateGuestPasses = useCallback(
    async (data) => {
      try {
        setIsLoading(true)
        await api.updateGuestPassesByClientId(clientId, data)
        setIsLoading(false)
      } catch (error) {
        setIsLoading(false)
        console.error('Error in fetchGuestPasses:', error)
      }
    },
    [clientId],
  )

  return {
    isLoading,
    fetchUpdateGuestPasses,
  }
}
